import React from 'react';
import {useLotto99} from "../../../store/lotto99/Lotto99Context";

const ResultHistoryMobile = () => {

    const {list} = useLotto99()
    return (
        <div className="results">
            <div className="list">
                {list && list?.map((e, i) => {
                    return <div key={i} className="item_99">
                        <span
                        style={{color: "rgb(90, 68, 168)", fontSize: "3vw"}}>{e.drawLabel}</span>
                        <div className="list-groups"><span style={{fontSize: "3vw", fontWeight: "bold"}}>ប៉ុស្តិ៍</span>
                            <div className="list-group">
                                {e.posts.map((p, j) => {
                                    return <div key={j} className="list-group-item-l99"><p
                                        className="item-group" style={{fontSize: "4vw", fontWeight: "bold"}}>{p.postCode}</p>
                                        <p className={`l99-post-${p.postCode} lotto99-ball`}>{p.number}</p></div>
                                })}
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>
    );
};

export default ResultHistoryMobile;